<template>
  <section class="black-bg">
    <div class="faqWrapper">
      <div class="around-md">
        <div>
          <h3 class="hero-subheading">
            Frequently Asked <span class="text-outline">Questions</span>
          </h3>

          <div class="faq" v-for="(question, i) in questions" :key="question.i">
            <button class="faq-clicker" @click="toggleFAQ(i)">
              <h4 class="faq-question" :class="{ 'is-open': isFAQOpen === i }">
                {{ question.question }}
              </h4>
              <div class="faq-expander" :class="{ 'is-open': isFAQOpen === i }">
                <span class="vert"></span>
                <span class="hori"></span>
              </div>
            </button>
            <div class="faq-answer" :class="{ 'is-open': isFAQOpen === i }">
              {{ question.answer }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { fetchDataFromBase } from "../services/fetchDataFromBase";
export default {
  name: "Frequentques",
  data() {
    return {
      questions: null,
      isFAQOpen: 0,
    };
  },
  methods: {
    toggleFAQ(i) {
      this.isFAQOpen = i;
    },
  },
  async created() {
    const data = await fetchDataFromBase("faq");
    this.questions = data;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hero-subheading {
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 1.5rem;
  color: var(--text-white);
}
.hero-subheading .text-outline {
  -webkit-text-stroke: 1.5px var(--text-white);
  color: var(--bg-black);
}
.faq {
  border-bottom: 1px solid var(--text-white);
}
.faq-clicker {
  background-color: transparent;
  border: 0;
  display: block;
  padding: 1.5rem 0;
  cursor: pointer;
  width: 100%;
  display: flex;
  text-align: left;
  align-items: center;
  justify-content: space-between;
}
.faq-question {
  color: var(--lighter-grey);
  font-size: 1.5rem;
  font-weight: 400;
}
.faq-clicker:hover .faq-question {
  color: var(--text-white);
}
.faq-question.is-open {
  color: var(--primary-color) !important;
  font-weight: 700;
}
.faq-answer {
  display: none;
}
.faq-answer.is-open {
  display: block;
  color: var(--text-white);
  font-size: 1.2rem;
  padding-bottom: 1.5rem;
}
.faq-expander {
  margin-left: auto;
  position: relative;
}
.faq-expander .vert,
.faq-expander .hori {
  display: block;
  width: 16px;
  height: 2px;
  background-color: var(--color-grey);
  transition: all 100ms linear;
}
.faq-expander .vert {
  transform: rotate(90deg);
}
.faq-expander.is-open .vert {
  transform: rotate(0);
}
.faq-expander .hori {
  margin-top: -2px;
}
.faqWrapper {
  max-width: 920px;
  margin: auto;
  padding: 6rem 2.5rem;
  margin-bottom: 3rem;
  margin-top: 3rem;
}
</style>
